/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UsePreconditionerCgEnum } from "./UsePreconditionerCgEnum";
import {
  UsePreconditionerCgEnumFromJSON,
  UsePreconditionerCgEnumFromJSONTyped,
  UsePreconditionerCgEnumToJSON,
  UsePreconditionerCgEnumToJSONTyped,
} from "./UsePreconditionerCgEnum";
import type { UseAdvection1dEnum } from "./UseAdvection1dEnum";
import {
  UseAdvection1dEnumFromJSON,
  UseAdvection1dEnumFromJSONTyped,
  UseAdvection1dEnumToJSON,
  UseAdvection1dEnumToJSONTyped,
} from "./UseAdvection1dEnum";

/**
 *
 * @export
 * @interface PhysicalSettings
 */
export interface PhysicalSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Options:
   * 0 = off
   * 1 = momentum conservative
   * 2 = energy conservative
   * 3 = combined momentum and energy conservative
   *
   *
   * * `0` - off
   * * `1` - momentum conservative
   * * `2` - energy conservative
   * * `3` - combined momentum and energy conservative
   */
  useAdvection1d: UseAdvection1dEnum;
  /**
   * Options:
   * 0 = off
   * 1 = standard
   *
   *
   * * `0` - off
   * * `1` - standard
   */
  useAdvection2d: UsePreconditionerCgEnum;
}

/**
 * Check if a given object implements the PhysicalSettings interface.
 */
export function instanceOfPhysicalSettings(value: object): value is PhysicalSettings {
  if (
    (!("useAdvection1d" in (value as Record<string, any>)) &&
      !("use_advection_1d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["useAdvection1d"] === undefined &&
      (value as Record<string, any>)["use_advection_1d"] === undefined)
  )
    return false;
  if (
    (!("useAdvection2d" in (value as Record<string, any>)) &&
      !("use_advection_2d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["useAdvection2d"] === undefined &&
      (value as Record<string, any>)["use_advection_2d"] === undefined)
  )
    return false;
  return true;
}

export function PhysicalSettingsFromJSON(json: any): PhysicalSettings {
  return PhysicalSettingsFromJSONTyped(json, false);
}

export function PhysicalSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhysicalSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    useAdvection1d: UseAdvection1dEnumFromJSON(json["use_advection_1d"]),
    useAdvection2d: UsePreconditionerCgEnumFromJSON(json["use_advection_2d"]),
  };
}

export function PhysicalSettingsToJSON(json: any): PhysicalSettings {
  return PhysicalSettingsToJSONTyped(json, false);
}

export function PhysicalSettingsToJSONTyped(
  value?: Omit<PhysicalSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    use_advection_1d: UseAdvection1dEnumToJSON(value["useAdvection1d"]),
    use_advection_2d: UsePreconditionerCgEnumToJSON(value["useAdvection2d"]),
  };
}
